<template>
	<div class="payment">
		<div class="fixation">
			<div class="hint">
				<div class="left">
					订单已经提交，请尽快支付！
					<span>订单号：{{series}}</span>
				</div>
				<div class="right">
					应付金额：{{money}}元
				</div>
			</div>
			<div class="payment">
				<div :class="'item '+(paymentIndex == index ? 'item-select' : '')" v-for="(item,index) in payment"
					:key="index" @click="paymentIndex = index">
					<div class="icon">
						<img :src="item.icon" alt="">
					</div>
					<div class="name">
						{{item.name}}
						<i class="el-icon-check" v-if="paymentIndex == index"></i>
					</div>
				</div>
			</div>
			<div class="agreement" v-if="type == 1">
				<el-checkbox v-model="checked"></el-checkbox>阅读并接受<router-link :to="{
					path:'/agreement',
					query:{
						id:'005e993ee1844ee2a1c98439de175d4a'
					}
				}">竞买协议</router-link>
			</div>
			<div class="button">
				<el-button type="danger" @click="doPay">立即支付</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'payment',
		data() {
			return {
				series: '',
				money: '',
				lotId: '',
				paymentIndex: 0,
				payment: [
					// {
					// 	icon: require('../../../assets/payment-unipay.png'),
					// 	name: '中国银联',
					// 	value: 1
					// },
					{
						icon: require('../../../assets/payment-wechat.png'),
						name: '微信支付',
						value: 2
					},
					{
						icon: require('../../../assets/payment-alipay.png'),
						name: '支付宝银联',
						value: 3
					}
				],
				checked: false
			};
		},
		methods: {
			fetchData() {
				if (this.type == 1) {

					this.$api.frontDepositDetail({
						id: this.series
					}, res => {
						if (res.code == 200) {
							this.money = res.data.bondPrice
							this.lotId = res.data.lotId
						}
					})
				} else {
					this.$api.frontOrderDetail({
						lotOrderId: this.series,
						userId: this.$store.state.userinfo.userId
					}, res => {
						if (res.code == 200) {
							this.money = res.data.payPrice
							this.lotId = res.data.lotId
						}
					})
				}
			},
			doPay() {
				if (this.type == 1 && !this.checked) {
					this.$message({
						message: '请阅读《竞买协议》后再继续。',
						type: 'error',
						duration: 2000
					})
					return
				}
				if (this.payment[this.paymentIndex]['value'] == 2) {
					this.$router.push({
						path: '/wechat',
						query: {
							order: this.series,
							type: this.type,
							lotId: this.lotId,
							money: this.money
						}
					})
				} else if (this.payment[this.paymentIndex]['value'] == 3) {
					this.$api.frontAliPay({
						orderNo: this.series,
						payType: this.type
					}, res => {
						if (res.code == 200) {
							window.open(res.data)
						}
					})
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.series = this.$route.query.order
			this.type = this.$route.query.type
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.fixation {
		margin-top: @vue-spacing-col-lg*2;

		.hint {
			width: 100%;
			height: 50px;
			display: flex;
			justify-content: space-between;
			font-size: @vue-font-size-base - 4;
			margin-bottom: @vue-spacing-col-base;

			.right {
				color: @vue-text-color-red;
			}
		}

		.payment {
			width: 100%;

			.item {
				width: 50%;
				height: 60px;
				display: flex;
				justify-content: space-between;
				margin-bottom: @vue-spacing-col-base;
				cursor: pointer;

				.icon {
					width: 60px;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.name {
					width: calc(100% - 60px);
					height: 100%;
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-right: @vue-spacing-row-lg;
					box-sizing: border-box;

					i {
						color: @vue-text-color-red;
						font-size: @vue-font-size-base;
						font-weight: bold;
					}
				}
			}

			.item-select {
				color: @vue-text-color-red;
				border: 2px solid @vue-border-color-red;
				box-sizing: border-box;
				border-radius: @vue-border-radius-base;
			}
		}

		.agreement {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm;

			a {
				color: @vue-text-color-active;
				margin: 0px @vue-spacing-row-sm / 2;
			}

			a:hover {
				color: @vue-text-color-red;
			}

			.el-checkbox {
				margin-right: @vue-spacing-row-sm;
			}
		}

		.button {
			width: 100%;
			margin: @vue-spacing-col-lg 0px;

			.el-button {
				width: 200px;
			}
		}
	}
</style>
